import Cookie from 'js-cookie';
import { setCookie } from '~/helpers/cookie';
import { v4 as uuid } from 'uuid';
import { BUY_FLOW } from '~/hooks/useBuyFlowDecision';

/**
 * Retrieves the existing processId from the cookie or creates a new one with the proper prefix.
 * @param cartFlow - The current cart flow.
 * @returns A processId string with the appropriate prefix.
 */
export const getOrCreateProcessId = (): string => {
  const cartFlow = Cookie.get('buyFlow') || BUY_FLOW.BAU;
  const existingProcessId = Cookie.get('processId');

  if (existingProcessId && existingProcessId.startsWith(cartFlow)) {
    return existingProcessId;
  }

  const processId = `${cartFlow}-${uuid()}`;
  setCookie('processId', processId, { otGroup: 'C0004' });
  return processId;
};
